export const actionTypes = {
  CHANGE_DAY: 'CHANGE_DAY',
  CHANGE_MODE: 'CHANGE_MODE',
  SET_DROPPED_MOMENT: 'SET_DROPPED_MOMENT',
  UNSET_DROPPED_MOMENT: 'UNSET_DROPPED_MOMENT',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
}

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_DAY:
      return {
        ...state,
        firstDayOfWeek: action.payload.firstDayOfWeek,
        focusedDay: action.payload.day,
      }
    case actionTypes.CHANGE_MODE:
      return {
        ...state,
        mode: action.payload,
      }
    case actionTypes.SET_DROPPED_MOMENT: {
      const droppedMoment = {
        movedFrom: action.payload.movedMomentFrom,
        movedTo: action.payload.movedMomentTo,
        id: action.payload.momentId,
        isActive: true,
      }

      return {
        ...state,
        droppedMoment,
      }
    }
    case actionTypes.UNSET_DROPPED_MOMENT:
      return {
        ...state,
        droppedMoment: null,
      }
    case actionTypes.SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
      }
    default:
      throw new Error('action taken on Calendar that cannot be handled')
  }
}
